import "./index.css"
import "./App.css";
import AppRoute from "./screen";
function App() {
  return (
   <>
    <AppRoute/>
   </>
  );
}

export default App;
